// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export default class CardsEnum {
    static TRIGGER_A11Y_LINK = '[data-trigger="card-a11y-link"]'
}
